







































































import { Component, Prop, Emit, Watch } from "vue-property-decorator";
import Vue from "vue";
// import CardModalPemeriksaan from "../components/modal/CardModalPemeriksaan.vue";
import DateFormat from "@/utility/DateFormat";

@Component({
  components: {
    // CardModalPemeriksaan
  }
})
export default class CardPemeriksaanDokter extends Vue {
  @Prop() soap: object;
  modalOpen = false;
  pemeriksaanDokter(item) {
    this.soap = item;
    this.modalOpen = true;
  }
  formatTgl(tgl) {
    return DateFormat.formatDate(tgl);
  }
}
